import * as api from "../constants/apiEndpoints";
import {APPLICATION_JSON_CONTENT_TYPE, GET, POST} from "../constants/postMessages";
import {clearStorage, getSessionToken} from "../actions/storage";

export const RESULT = {
  OK: "ok",
  FAILED: "failed",
  SESSION_EXPIRED: "sessionExpired",
};

export const NETWORK_FAILURE_STATUS = 0;

const RESPONSE_TYPE = {
  JSON: "json",
  TEXT: "text",
};

let isSessionChecked = false;

const failed = (status, code, reason) => ({
  kind: RESULT.FAILED,
  status,
  code: code || null,
  reason: reason || null,
});

const sessionExpired = () => {
  clearStorage();
  return {kind: RESULT.SESSION_EXPIRED};
};

const isJson = (response) =>
    (response.headers.get("content-type") || "").includes(APPLICATION_JSON_CONTENT_TYPE);

// Error bodies are not always JSON: a missing session header yields a plain-text 400.
const readFailure = (response) => {
  if (!isJson(response)) {
    return Promise.resolve(failed(response.status, null, response.statusText));
  }
  return response.json().then(
      body => failed(response.status, body && body.errorMessage, (body && body.reason) || response.statusText),
      () => failed(response.status, null, response.statusText));
};

const readSuccess = (response, responseType) => {
  const body = responseType === RESPONSE_TYPE.TEXT ? response.text() : response.json();
  return body.then(
      value => ({kind: RESULT.OK, status: response.status, body: value}),
      () => failed(response.status, null, response.statusText));
};

const request = (url, {method = GET, body, authenticated = false, responseType = RESPONSE_TYPE.JSON} = {}) => {
  const sessionToken = getSessionToken();
  if (authenticated && !sessionToken) {
    return Promise.resolve(sessionExpired());
  }
  const headers = {};
  if (body !== undefined) {
    headers["Content-Type"] = APPLICATION_JSON_CONTENT_TYPE;
  }
  if (authenticated) {
    headers["x-imp-session-token"] = sessionToken;
  }
  return fetch(url, {method, headers, body: body === undefined ? undefined : JSON.stringify(body)})
  .then(response => {
    if (response.ok) {
      return readSuccess(response, responseType);
    }
    if (authenticated && response.status === 403) {
      return sessionExpired();
    }
    return readFailure(response);
  }, () => failed(NETWORK_FAILURE_STATUS, null, null));
};

/* Auth */
export const authApi = (authToken, idpInstanceId, applianceUuid, capabilities) => {
  return request(api.AUTHENTICATE, {
    method: POST,
    body: {authToken, idpInstanceId, applianceUuid, capabilities},
  });
}

export const checkSession = (history) => {
  if (!isSessionChecked) {
    isSessionChecked = true;
    history.push({
          pathname: '/auth',
          state: {previousPage: history.location.pathname}
        }
    );
    return false;
  } else {
    return true;
  }
}

/* Standard Based Application */
export const createOidcClientCredentialsApi = () => {
  return request(api.CREATE_OIDC_CLIENT_CREDENTIALS, {authenticated: true});
}

export const createSbaAppApi = (newMeta) => {
  return request(api.CREATE_SBA_APP, {method: POST, body: newMeta, authenticated: true});
}

/* Logout */
export const logoutApi = () => {
  return request(api.LOGOUT, {authenticated: true, responseType: RESPONSE_TYPE.TEXT});
}
